var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"text main-text"},[_vm._v("欢迎使用 "+_vm._s(this.$project.projectName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }